// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"BasicFormInput_inputContainer__36FNZ","input":"BasicFormInput_input__2CNyv","label":"BasicFormInput_label__1Xw59"};